<template>
  <div
    style="width: 100%"
    :class="mobile ? 'custom-fields custom-fields--mobile' : 'mx-0 my-2'"
  >
    <template v-if="!mobile">
      <v-divider class="mb-4" />
      <v-row
        class="mb-3"
        style="height: 28px"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              small
              color="primary"
              class="mt-2"
              v-on="on"
              text
              @click="addRow"
            >
              {{ $t('addCustomeField') }}
            </v-btn>
          </template>
          <span>{{ $t('clickForAddCustomeField') }}</span>
        </v-tooltip>
      </v-row>
      <v-row
        v-for="(item, i) in items"
        :key="i"
      >
        <v-col
          cols="12"
          md="4"
          class="mb-0"
        >
          <v-combobox
            v-model="item.key"
            :items="keyItems"
            :search-input.sync="search"
            hide-selected
            :rules="[v => !!v || $t('is-required')]"
            :label="$t('additionalFields')"
            outlined
            value="key"
            dense
            :multiple="(multiple ? multiple : false)"
            small-chips
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t('toCreate') }} : "<strong>{{ search }}</strong>". {{ $t('doEnter') }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-slot:item="{ index, item: option }">
              {{ option }}
              <v-spacer />
              <v-list-item-action
                class="d-inline"
                @click.stop
              >
                <v-btn
                  icon
                  small
                  @click.stop.prevent="edit(index, option)"
                >
                  <v-icon color="grey">
                    mdi-pencil
                  </v-icon>
                </v-btn>
              </v-list-item-action>
            </template>
          </v-combobox>
        </v-col>
        <v-col
          cols="12"
          md="4"
          class="mb-0"
        >
          <v-text-field
            v-model="item.value"
            :label="$t('value')"
            height="20"
            dense
            :rules="[v => !!v || $t('is-required')]"
            outlined
            class="mb-1 dense"
            clearable
          />
        </v-col>
        <v-col
          cols="12"
          sm="4"
          md="4"
          class=""
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="pink"
                icon
                small
                v-bind="attrs"
                class="ms-2 pt-1"
                v-on="on"
                @click="removeRow(item)"
              >
                <v-icon
                  color="pink"
                  style="font-size: 26px"
                >
                  mdi-close
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('remove') }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </template>

    <template v-else>
      <div
        v-if="!items || !items.length"
        class="custom-fields__empty"
      >
        هنوز فیلد دلخواهی اضافه نشده است.
      </div>

      <div
        v-for="(item, i) in items"
        :key="'cf-' + i"
        class="custom-fields__card"
      >
        <div class="custom-fields__card-head">
          <div class="custom-fields__field custom-fields__card-main">
            <div class="custom-fields__label">{{ $t('additionalFields') }}</div>
            <v-combobox
              v-model="item.key"
              :items="keyItems"
              :search-input.sync="search"
              hide-selected
              :rules="[v => !!v || $t('is-required')]"
              solo
              flat
              dense
              hide-details
              height="40"
              append-icon="mdi-chevron-down"
              :multiple="(multiple ? multiple : false)"
              class="custom-fields__control"
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $t('toCreate') }} : "<strong>{{ search }}</strong>". {{ $t('doEnter') }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <template v-slot:item="{ index, item: option }">
                {{ option }}
                <v-spacer />
                <v-list-item-action
                  class="d-inline"
                  @click.stop
                >
                  <v-btn
                    icon
                    small
                    @click.stop.prevent="edit(index, option)"
                  >
                    <v-icon color="grey">
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </v-list-item-action>
              </template>
            </v-combobox>
          </div>
          <button
            type="button"
            class="custom-fields__remove"
            :aria-label="$t('remove')"
            @click="removeRow(item)"
          >
            <v-icon size="20" color="#E91E63">mdi-close</v-icon>
          </button>
        </div>

        <div class="custom-fields__field">
          <div class="custom-fields__label">{{ $t('value') }}</div>
          <input
            v-model="item.value"
            type="text"
            class="custom-fields__input"
            :placeholder="$t('value')"
            autocomplete="off"
          >
        </div>
      </div>
    </template>

    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="dialog"
      width="300"
    >
      <v-card
        v-if="editing"
        class="pl-4"
      >
        <v-col class="mt-3 pr-7">
          <v-text-field
            v-model="editingText"
            filled
            dense
            autofocus
            flat
            :loading="loading"
            :disabled="loading"
          />
        </v-col>
        <v-card-actions>
          <v-btn
            color="primary"
            text
            :loading="loading"
            @click="updateItem"
          >
            {{ $t('edit') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    data: () => ({
      keyItems: [],
      items: [],
      loading: false,
      dialog: false,
      model: null,
      selected: null,
      lastPage: 1,
      search: null,
      type: null,
      editing: null,
      editingText: null,
      removeText: null,
      oldText: null,
      editingColor: null,
      page: 1,
    }),
    props: {
      value: {
        default: null,
      },
      typeProp: {
        type: String,
        default: null,
      },
      multiple: {
        type: Boolean,
        default: false,
      },
      mobile: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      isMobile () {
        return this.$vuetify && this.$vuetify.breakpoint
          ? this.$vuetify.breakpoint.mobile
          : false
      },
    },
    watch: {
      value (val) {
        this.items = val
      },
      items: {
        handler () {
          this.$emit('input', this.items)
        },
        deep: true,
      },
      search () {
        this.getItems()
      },
    },
    mounted () {
      if (this.value) {
        this.items = this.value
      }
      this.type = this.$route.params.type
      this.getItems()
    },
    methods: {
      addRow () {
        var row = {
          key: null,
          value: null,
        }
        this.items.push(row)
      },
      edit (index, item) {
        this.editing = item
        this.editingText = item
        this.oldText = item
        this.dialog = true
      },
      getItems () {
        var app = this
        app.loading = true
        clearTimeout(app.timer)
        app.timer = setTimeout(function () {
          app.$axios.get(app.$endpoint + 'getdetail', {
            params: {
              select: app.typeProp,
              search: app.search,
            },
          })
            .then(res => {
              res = res.data
              app.keyItems = res
            })
            .catch(err => {
              app.serverErrorHandeler(err)
            })
            .finally(function () {
              app.loading = false
            })
        }, 1000)
      },
      updateItem () {
        var app = this
        app.loading = true
        clearTimeout(app.timer)
        app.timer = setTimeout(function () {
          app.$axios.get(app.$endpoint + 'getdetail', {
            params: {
              select: 'editCustomFields',
              type: app.typeProp,
              oldKey: app.oldText,
              key: app.editingText,
            },
          })
            .then(() => {
              app.getItems()
            })
            .catch(err => {
              app.serverErrorHandeler(err)
            })
            .finally(function () {
              app.loading = false
              app.dialog = false
              app.editingText = null
              app.oldText = null
            })
        }, 1000)
      },
      removeRow (item) {
        var i = this.items.indexOf(item)
        this.items.splice(i, 1)
      },
      visibilityChanged () {
        // this.page++
        // e && this.getItems()
      },
      keydown: function () {
      },
      submit () {
      },
      filter (item, queryText, itemText) {
        if (item.header) return false

        const hasValue = val => val != null ? val : ''

        const text = hasValue(itemText)
        const query = hasValue(queryText)

        return text.toString()
          .toLowerCase()
          .indexOf(query.toString().toLowerCase()) > -1
      },
    },
  }
</script>

<style scoped>
.custom-fields--mobile {
  display: flex;
  flex-direction: column;
  gap: 0;
  margin: 0;
}
.custom-fields__empty {
  margin-bottom: 4px;
  padding: 16px;
  border: 1px dashed #cfd8dc;
  border-radius: 12px;
  text-align: center;
  font-size: 13px;
  font-weight: 600;
  color: #90a4ae;
}
.custom-fields__card {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 12px;
  padding: 12px;
  border: 1px solid #e0e4e8;
  border-radius: 12px;
  background: #fff;
}
.custom-fields__card:last-child {
  margin-bottom: 0;
}
.custom-fields__card-head {
  display: flex;
  align-items: flex-end;
  gap: 8px;
}
.custom-fields__card-main {
  flex: 1 1 auto;
  min-width: 0;
}
.custom-fields__remove {
  flex: 0 0 40px;
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #f8bbd0;
  border-radius: 10px;
  background: #fce4ec;
  cursor: pointer;
}
.custom-fields__field {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
}
.custom-fields__label {
  display: block;
  margin: 0 2px 6px;
  font-size: 13px;
  font-weight: 600;
  color: #455a64;
  line-height: 1.4;
  text-align: right;
}
.custom-fields__control {
  flex: none !important;
  width: 100%;
  height: 40px !important;
  max-height: 40px !important;
  min-height: 40px !important;
  margin: 0 !important;
  padding: 0 !important;
  overflow: hidden !important;
}
.custom-fields__control.v-input {
  margin: 0 !important;
  min-height: 40px !important;
  height: 40px !important;
  max-height: 40px !important;
}
.custom-fields__control ::v-deep .v-input__control {
  min-height: 40px !important;
  height: 40px !important;
  max-height: 40px !important;
  margin: 0 !important;
}
.custom-fields__control ::v-deep .v-input__slot {
  min-height: 40px !important;
  height: 40px !important;
  max-height: 40px !important;
  margin: 0 !important;
  padding: 0 12px !important;
  border: 1px solid #cfd8dc !important;
  border-radius: 8px !important;
  background: #fff !important;
  box-shadow: none !important;
}
.custom-fields__control ::v-deep .v-input__slot::before,
.custom-fields__control ::v-deep .v-input__slot::after {
  display: none !important;
}
.custom-fields__control ::v-deep .v-input__append-inner,
.custom-fields__control ::v-deep .v-input__prepend-inner {
  margin-top: 0 !important;
  align-self: center !important;
}
.custom-fields__control ::v-deep .v-select__selections {
  flex-wrap: nowrap;
  overflow: hidden;
  min-height: 0 !important;
  padding: 0 !important;
}
.custom-fields__control ::v-deep .v-select__selection {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0 !important;
}
.custom-fields__control ::v-deep .v-select__selection,
.custom-fields__control ::v-deep input {
  margin: 0 !important;
  font-size: 15px;
  font-weight: 700;
  color: #37474f;
}
.custom-fields__input {
  width: 100%;
  height: 40px;
  padding: 0 10px;
  border: 1px solid #cfd8dc;
  border-radius: 8px;
  outline: none;
  background: #fff;
  text-align: right;
  font-size: 15px;
  font-weight: 600;
  color: #37474f;
  box-sizing: border-box;
}
.custom-fields__input:focus {
  border-color: #90caf9;
  background: #e3f2fd;
}
</style>
